// Should display the users direct messages 

const Messages = () => {
    return (
        <div>Messages will live here</div>
    )

}

export default Messages